import {HttpClientInterface} from "../index";
import {Deployment, deploymentFactory} from "./models/Deployment";
import {APIResponse, parseItemResponse, parseItemsResponse} from "../ModelFactory";
import {Entity, entityFactory} from "./models/Entity";
import {ReportedMonth, reportedMonthFactory} from "./models/ReportedMonth";
import {ReportedTenant, reportedTenantFactory} from "./models/ReportedTenant";
import {permissionMapFactory} from "../common/models/PermissionMap";
import {Contract, contractFactory} from "../partner/models/Contract";

export class AdminApiClient {
  constructor(private http: HttpClientInterface) {}

  // Deployments
  public async getAllDeployments({page = 1}): Promise<APIResponse<Deployment[]>> {
    const json = await this.http.get<{items: object[]}>(`deployments?page=${page}`)
    return parseItemsResponse(json, deploymentFactory)
  }
  public async retryDeployement(entityId: string, deploymentId: string): Promise<null> {
    await this.http.post(`entities/${entityId}/deployments/${deploymentId}/retry`, {})
    return null
  }
  public async getEntityDeployments(entityId: string): Promise<APIResponse<Deployment[]>> {
    const json = await this.http.get<{items: object[]}>(`entities/${entityId}/deployments`)
    return parseItemsResponse(json, deploymentFactory)
  }

  // Entities
  public async getFailedEntities(): Promise<APIResponse<Entity[]>> {
    const json = await this.http.get<{items: object[]}>('entities/failed')
    return parseItemsResponse(json, entityFactory)
  }

  // Billing
  public async getPastYearMonthlyTurnover(): Promise<APIResponse<ReportedMonth[]>> {
    // TODO: Implement this on the API side
    const json = await this.http.get<{items: object[]}>('billing/reports/monthly_turnover')
    return parseItemsResponse(json, reportedMonthFactory)
  }
  public async getMRRPerTenant(): Promise<APIResponse<ReportedTenant[]>> {
    const json = await this.http.get<{items: object[]}>('billing/reports/mrr_per_tenant')
    return parseItemsResponse(json, reportedTenantFactory)
  }
  public async getUnbilledContractsValue(): Promise<number> {
    const json = await this.http.get<{value: number}>('billing/reports/unbilled_contracts_value')
    return json['value']
  }

  public async getMRR(): Promise<number> {
    const json = await this.http.get<{value: number}>('billing/reports/mrr')
    return json['value']
  }

  public async getUpcomingRenewalContracts(): Promise<APIResponse<Contract[]>> {
    const json = await this.http.get<{items: object[]}>('billing/reports/upcoming_renewal_contracts')
    return parseItemsResponse(json, contractFactory)
  }

  public async getMrrPerCategory(): Promise<{[category: string]: number}> {
    const json = await this.http.get<{data: {[category: string]: number}}>('billing/reports/mmr_per_entity_type')
    return json.data
  }

  public async getLifetimeRevenuePerTenant(): Promise<{tenant: string, value: number}[]> {
    const json = await this.http.get<{data: {tenant: string, value: number}[]}>('billing/reports/lifetime_revenue')
    return json.data
  }

  // Permissions
  public async getPermissions() {
    // TODO: Resolve permissions from API
    return parseItemResponse({item: {}}, permissionMapFactory)
  }
}

